// AppBars = footer style for normal mode
// AppBar1 = footer style when sidebar is in use
import { AppBars, AppBar1 } from "./Footer.styles";

// ToolbarUI contains the actual footer links/buttons
import ToolbarUI from "./ToolbarUI";

// Context gives info about sidebar visibility (expanded/collapsed)
import { useSidebarContext } from "../sidebar";

/**
 * Footer Component
 *
 * Renders a bottom AppBar (footer).
 * - If `withSidebar = false` → full width footer (AppBars)
 * - If `withSidebar = true` → sidebar-aware footer (AppBar1), shifts with sidebar
 *
 * @param {boolean} withSidebar - Determines if footer should adapt to sidebar layout
 */
const Footer = ({ withSidebar = false }) => {
  // Get sidebar state from context
  const { showSidebar } = useSidebarContext();

  // If sidebar support is enabled
  if (withSidebar) {
    return (
      <AppBar1
        component="footer"
        position="fixed"
        open={showSidebar} // tells AppBar1 if sidebar is open
        sx={{ top: "auto", bottom: 0 }} // always sticks to bottom
      >
        <ToolbarUI /> {/* Footer content (FAQ, Support, Feedback, Terms) */}
      </AppBar1>
    );
  }

  // Default footer (no sidebar adjustment)
  return (
    <AppBars component="footer" position="fixed" sx={{ top: "auto", bottom: 0 }}>
      <ToolbarUI /> {/* Footer content */}
    </AppBars>
  );
};

export default Footer;
